export const Mixins = {
  data() {
    return {
      // 所有下拉列表
      listData: {    
        // 小吃 小药 家园酒
        drug: {
          zqxyOptions: [],
          //TODO 更新小吃列表
          zqxcOptions: [{
            code: "taiHouBing",
            name: "太后饼"
          },
          {
            code: "jianBingGuoZi",
            name: "煎饼果子"
          },
          {
            code: "null",
            name: "无"
          }
          ],
          //TODO 更新小吃列表
          fzxyOptions: [{
            code: "shangPinQingShenDan",
            name: "上品轻身丹"
          },
          {
            code: "ZhongPinQingShenDan",
            name: "中品轻身丹"
          },
          {
            code: "null",
            name: "无"
          }
          ],
          fzxcOptions: [{
            code: "zaJinYuQiuZhou",
            name: "杂锦鱼球粥"
          },
          {
            code: "zaSuiTang",
            name: "杂碎汤"
          },
          {
            code: "null",
            name: "无"
          }
          ],
          // 磨石 桌子
          wqmsOptions: [{
            code: "baoShaRongDing",
            name: "爆沙熔锭"
          },
          {
            code: "baoShaMoShi",
            name: "爆沙磨石"
          },
          {
            code: "null",
            name: "无"
          }
          ],
          jyxcOptions: [{
            code: "chuangYiLiaoLi-gongJi",
            name: "创意-攻击"
          },
          {
            code: "chuangYiLiaoLi-huiXin",
            name: "创意-会心"
          },
          {
            code: "chuangYiLiaoLi-poFang",
            name: "创意-破防"
          },
          {
            code: "chuangYiLiaoLi-wuShuang",
            name: "创意-无双"
          },
          {
            code: "huLuJiaoHuaJi",
            name: "葫芦叫花鸡"
          },
          {
            code: "null",
            name: "无"
          },
          ],
          jyxjOptions: [{
            code: "guaiWaiBaiJiu",
            name: "关外白酒-紫色"
          },
          {
            code: "null",
            name: "无"
          }
          ],
          tdyxOptions: [{
            code: "yuDiSheiJiaTingLuoMei",
            name: "断浪-玉笛",
            disable: false,
            type: 1
          },
          {
            code: "shuiJingFuRongYan",
            name: "水晶芙蓉宴",
            disable: false,
            type: 1
          },
          {
            code: "tongZeYan",
            name: "同泽宴",
            disable: false,
            type: 2
          },
          {
            code: "baiLianShuiZhuYu",
            name: "百炼水煮鱼",
            disable: false,
            type: 3
          },
          {
            code: "zhengYuCaiPan",
            name: "蒸鱼菜盘",
            disable: false,
            type: 4
          }
          ]
        },
        position: {
          positionOptions: [{
            code: "lingXueZiJiZhen",
            name: "凌雪阵(自己)",
            damageAddition: 0

          },
          {
            code: "wanLingShanZhuangCongZhuZhen",
            name: "万灵阵(聚势)",
            damageAddition: 0
          },
          {
            code: "lingXueZhen",
            name: "凌雪阵(别人)",
            damageAddition: 0
          },
          {
            code: "pengLaiZhen",
            name: "蓬莱阵",
            damageAddition: 0
          },
          {
            code: "gaiBangZhen",
            name: "丐帮阵",
            damageAddition: 0
          },
          {
            code: "wanLingShanZhuangZhen",
            name: "万灵阵",
            damageAddition: 0
          },
          {
            code: "jianChunZhen",
            name: "剑纯阵",
            damageAddition: 0
          },
          {
            code: "cangJianZhen",
            name: "藏剑阵",
            damageAddition: 0
          },
          {
            code: "wuJieZhen",
            name: "无界阵",
            damageAddition: 0
          },
          {
            code: "jingYuZhen",
            name: "鲸鱼阵",
            damageAddition: 0
          },
          {
            code: "daoZongZhen",
            name: "刀宗阵",
            damageAddition: 0
          },
          {
            code: "tianLuoZhen",
            name: "田螺阵",
            damageAddition: 0
          }

          ],
        },
        enemy: [
          {
            code: "muZhuang134",
            name: "134级"
          },
          {
            code: "muZhuang133",
            name: "133级"
          },
          {
            code: "muZhuang132",
            name: "132级"
          },
          {
            code: "muZhuang131",
            name: "131级"
          }
        ],
        loop: {
          delayOptions: [
            {
              code: "2",
              name: "125ms",
            }, 
            {
              code: "1.6",
              name: "100ms",
            }, 
            {
              code: "1.2",
              name: "75ms",
            }, 
            {
              code: "1",
              name: "62.5ms",
            }, 
            {
              code: "0.8",
              name: "50ms",
            }, 
            {
              code: "0.6",
              name: "37.5ms",
            }, 
            {
              code: "0.4",
              name: "25ms",
            }, 
            {
              code: "0",
              name: "0ms",
            }],
          computeStrategyOptions: [{
            code: "commonComputeStrategyImpl",
            name: "理想计算"
          },
          {
            code: "guoComputeStrategyImpl",
            name: "郭氏计算"
          }],
          dataSourceOptions: [{
            code: "page",
            name: "页面数据"
          },
          {
            code: "peiZhuang",
            name: "配装数据"
          }],
        },
      },
      // 验证规则
      attributeRules: {
        jcgj: {
          required: true,
          message: "请填写基础攻击",
          trigger: "blur"
        },
        wqsh: {
          required: true,
          message: "",
          trigger: "blur"
        },
        wqshMin: {
          required: true,
          message: "请填写武伤",
          trigger: "blur"
        },
        wqshMax: {
          required: true,
          message: "请填写武伤",
          trigger: "blur"
        },
        jchx: {
          required: true,
          message: "请填写基础会心",
          trigger: "blur"
        },
        jchxxg: {
          required: true,
          message: "请填写会心效果",
          trigger: "blur"
        },
        jcws: {
          required: true,
          message: "请填写基础无双",
          trigger: "blur"
        },
        jcpf: {
          required: true,
          message: "请填写基础破防",
          trigger: "blur"
        },
        jcpz: {
          required: true,
          message: "请填写基础破招",
          trigger: "blur"
        },
        jcsf: {
          required: true,
          message: "请填写基础身法",
          trigger: "blur"
        },
        import: ""
      },
    }
  },
  methods: {
    init() {
      // this.income = {
      //   drug: {},
      //   buff: {
      //     hanRuLei: false,
      //     zuoXuanYouZhuan: false,
      //     zhenFen: false,
      //     xiuQi: false,
      //     hanXiaoQianjun: false,
      //     meiHuaSanNong: false,
      //     xianWangGuDing: false,
      //     sheShenHongFa: false,
      //     haoLingSanJun: false,
      //     zhenFenNum: 60,
      //     haoLingSanJunNum: 48,
      //     sheShenHongFaNum: 36
      //   },
      //   equipment: {},
      //   greatEnchantment: {
      //     cap: false,
      //     clothing: false,
      //     waistband: false,
      //     wrister: false,
      //     shoe: false
      //   }
      // };
    }
  }
}
